import React from 'react';
import { Box } from '@mui/material';
import DraftBundleDashboard from '../components/bundle/DraftBundleDashboard';
import { BundleCreationProvider } from '../contexts/BundleCreationContext';

const DraftsPage: React.FC = () => {
    return (
        // Full-bleed: no maxWidth Container cap. The dashboard owns its own horizontal
        // padding (via its root Box px) so it spans the entire content width.
        <Box sx={{ width: '100%' }}>
            <BundleCreationProvider>
                <DraftBundleDashboard />
            </BundleCreationProvider>
        </Box>
    );
};

export default DraftsPage;
